// extracted by mini-css-extract-plugin
module.exports = {"size":"color-picker_size__20WDn"};